import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';

import Carousel from './../components/slick';

import animated1 from './../assets/img/animated1.svg';
import animated2 from './../assets/img/animated2.svg';
import animated3 from './../assets/img/animated3.svg';
import model from './../assets/img/model.svg';
import school from './../assets/img/services/school.svg';
import anchor from './../assets/img/services/anchor.svg';
import initiation from './../assets/img/services/initiation.svg';
import financing from './../assets/img/services/financing.svg';
import conception from './../assets/img/services/conception.svg';
import representative from './../assets/img/services/representative.svg';
import map from './../assets/img/map.svg';
import derwin from './../assets/img/derwin.jpg';
import nora from './../assets/img/nora.jpg';

import Lighthouse from './../assets/img/projects/lighthouse-1.jpg';
import Clayborn from './../assets/img/projects/clayborn-3.jpg';
import Tulsa from './../assets/img/projects/tulsa-3.jpg';

import Pin from 'react-icons/lib/fa/circle';
import Twitter from 'react-icons/lib/fa/twitter-square';
import Facebook from 'react-icons/lib/fa/facebook-square';
import Instagram from 'react-icons/lib/fa/instagram';
import LinkedIn from 'react-icons/lib/fa/linkedin-square';
import Plus from 'react-icons/lib/io/ios-plus-outline';
import ArrowDown from 'react-icons/lib/io/ios-arrow-thin-down';


const Home = ({ data }) => {
  const cms = data.allMarkdownRemark.edges[0].node.frontmatter;

  function showGraphic() {
    const graphic = document.querySelector('.animated-graphic');
    graphic.classList.remove('out-of-view');
  }

  function hideGraphic() {
    const graphic = document.querySelector('.animated-graphic');
    graphic.classList.add('out-of-view');
  }

  function animateStage1() {
    const graphic = document.querySelector('.animated-graphic');
    graphic.src = `${animated1}`;
    graphic.style.transform = 'rotate(-5deg)';
  }

  function animateStage2() {
    const graphic = document.querySelector('.animated-graphic');
    graphic.src = `${animated2}`;
    graphic.style.transform = 'rotate(5deg)';
  }

  function animateStage3() {
    const graphic = document.querySelector('.animated-graphic');
    graphic.src = `${animated3}`;
    graphic.style.transform = 'rotate(-5deg)';
  }

  function expandBubble(e) {
    const selectedBubble = e.target.parentNode;
    const otherBubbles = document.querySelectorAll('.bubble');

    otherBubbles.forEach(bubble => {
      bubble.classList.remove('bubble-expanded');
    });

    selectedBubble.classList.add('bubble-expanded');
  }

  function closeBubble() {
    const bubbles = document.querySelectorAll('.bubble');

    bubbles.forEach(bubble => {
      bubble.classList.remove('bubble-expanded');
    });
  }

  function showExploreServices() {
    const exploreServices = document.querySelector('.services-container');
    const exploreButtonPlus = document.querySelector('.explore-button-plus');

    exploreServices.classList.toggle('services-visible');
    exploreButtonPlus.classList.toggle('plus-rotated');
  }

  function showYes(e) {
    const button = e.target;
    const otherButton = button.nextSibling;
    const NoNoButton = document.querySelector('#no .button-no');
    const NoYesButton = document.querySelector('#no .button-yes');
    const Yes = document.querySelector('#yes');
    const No = document.querySelector('#no');
    const NoNo = document.querySelector('#no-no');
    const NoYes = document.querySelector('#no-yes');

    button.classList.add('button-selected');
    Yes.classList.add('visible');

    otherButton.classList.remove('button-selected');
    NoNoButton.classList.remove('button-selected');
    NoYesButton.classList.remove('button-selected');
    No.classList.remove('visible');
    NoNo.classList.remove('visible');
    NoYes.classList.remove('visible');
  }

  function showYesNo(e) {
    const button = e.target;
    const otherButton = button.previousSibling;
    const YesNo = document.querySelector('#yes-no');
    const YesYes = document.querySelector('#yes-yes');
    const NoNo = document.querySelector('#no-no');
    const NoYes = document.querySelector('#no-yes');

    button.classList.add('button-selected');
    YesNo.classList.add('visible');

    otherButton.classList.remove('button-selected');
    YesYes.classList.remove('visible');
    NoNo.classList.remove('visible');
    NoYes.classList.remove('visible');
  }

  function showYesYes(e) {
    const button = e.target;
    const otherButton = button.nextSibling;
    const YesYes = document.querySelector('#yes-yes');
    const YesNo = document.querySelector('#yes-no');
    const NoNo = document.querySelector('#no-no');
    const NoYes = document.querySelector('#no-yes');

    button.classList.add('button-selected');
    YesYes.classList.add('visible');

    otherButton.classList.remove('button-selected');
    YesNo.classList.remove('visible');
    NoNo.classList.remove('visible');
    NoYes.classList.remove('visible');
  }

  function showNo(e) {
    const button = e.target;
    const yesButton = button.previousSibling;
    const YesNoButton = document.querySelector('#yes .button-no');
    const YesYesButton = document.querySelector('#yes .button-yes');
    const No = document.querySelector('#no');
    const Yes = document.querySelector('#yes');
    const YesNo = document.querySelector('#yes-no');
    const YesYes = document.querySelector('#yes-yes');

    button.classList.add('button-selected');
    No.classList.add('visible');

    yesButton.classList.remove('button-selected');
    YesNoButton.classList.remove('button-selected');
    YesYesButton.classList.remove('button-selected');
    Yes.classList.remove('visible');
    YesNo.classList.remove('visible');
    YesYes.classList.remove('visible');
  }

  function showNoNo(e) {
    const button = e.target;
    const otherButton = button.previousSibling;
    const NoNo = document.querySelector('#no-no');
    const NoYes = document.querySelector('#no-yes');
    const YesNo = document.querySelector('#yes-no');
    const YesYes = document.querySelector('#yes-yes');

    button.classList.add('button-selected');
    NoNo.classList.add('visible');

    otherButton.classList.remove('button-selected');
    NoYes.classList.remove('visible');
    YesNo.classList.remove('visible');
    YesYes.classList.remove('visible');
  }

  function showNoYes(e) {
    const button = e.target;
    const otherButton = button.nextSibling;
    const NoYes = document.querySelector('#no-yes');
    const NoNo = document.querySelector('#no-no');
    const YesNo = document.querySelector('#yes-no');
    const YesYes = document.querySelector('#yes-yes');

    button.classList.add('button-selected');
    NoYes.classList.add('visible');

    otherButton.classList.remove('button-selected');
    NoNo.classList.remove('visible');
    YesNo.classList.remove('visible');
    YesYes.classList.remove('visible');
  }

  function showNoYesMore() {
    const noYesMore = document.querySelector('#no-yes-more');
    noYesMore.classList.toggle('visible');
  }

  function enterBlockContact() {
    const block = document.querySelector('#yes-yes-contact');
    block.classList.add('visible-animated');
  }

  function expandBio(e) {
    const selectedBubble = e.target.parentNode;
    const otherBubbles = document.querySelectorAll('.person-box');

    otherBubbles.forEach(bubble => {
      bubble.classList.remove('bio-expanded');
    });

    selectedBubble.classList.add('bio-expanded');
  }

  function closeBio() {
    const bubbles = document.querySelectorAll('.person-box');

    bubbles.forEach(bubble => {
      bubble.classList.remove('bio-expanded');
    });
  }

  return (
    <div className="home">
      <Helmet
          title="Maslow Development Inc."
          meta={[
            { name: 'description', content: 'We co-design & develop real estate and community ecosystems.' },
            { name: 'keywords', content: 'maslow, maslow development, maslow development inc, real estate, community development, community developer, community planner, real estate development, real estate developer, real estate design, real estate designer' }
          ]}
      />

      <section className="hero">
        <div className="layer" />
        <hgroup className="hero-content">
          <h1>
            <span>
              We <i>co-design & develop</i> real estate
            </span>
            <span>and community ecosystems.</span>
          </h1>
          <div className="divider" />
        </hgroup>
      </section>

      <section className="infographic">
        <div className="background-letters" />
        <h3 className="header">{cms.infographicHeader}</h3>
        <Carousel />
      </section>

      <section className="transition">
        <div className="layer" />
        <h3>{cms.infographicCloser}</h3>
      </section>

      <section className="illustration" id="our-story">
        <div className="graphic-container">
          <img src={animated1} className="animated-graphic out-of-view" />
        </div>
        <Waypoint onEnter={showGraphic} onLeave={hideGraphic}>
          <div className="waypoint-container" />
        </Waypoint>

        <div className="panels-container">
          <span className="section-arrow-grey">▼</span>
          <div className="panel panel-1">
            <Waypoint onEnter={animateStage1} bottomOffset="25%" />
            <h3>{cms.illustration1Header}</h3>
            <p>{cms.illustration1Description}</p>
          </div>
          <div className="panel panel-2">
            <Waypoint onEnter={animateStage2} bottomOffset="25%" />
            <h3>{cms.illustration2Header}</h3>
            <p>{cms.illustration2Description}</p>
          </div>
          <div className="panel panel-3">
            <Waypoint onEnter={animateStage3} bottomOffset="25%" />
            <h3>{cms.illustration3Header}</h3>
            <p>{cms.illustration3Description}</p>
          </div>
        </div>
      </section>

      <section className="values" id="our-values">
        <div className="background-click-zone" onClick={closeBubble} />
        <div className="background-letters" />
        <span className="section-arrow-white">▼</span>
        <h1>{cms.valuesHeader}</h1>
        <div className="bubble-container">
          <div className="bubble bubble-1">
            <div className="bubble-handler" onClick={expandBubble} />
            <span className="value-x" onClick={closeBubble}>✕</span>
            <div className="value-main">
              <h3>{cms.value1Name}</h3>
              <p className="value-subheader">{cms.value1Blurb}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="value-description">
              <p>{cms.value1Description}</p>
            </div>
          </div>
          <div className="bubble bubble-2">
            <div className="bubble-handler" onClick={expandBubble} />
            <span className="value-x" onClick={closeBubble}>✕</span>
            <div className="value-main">
              <h3>{cms.value2Name}</h3>
              <p className="value-subheader">{cms.value2Blurb}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="value-description">
              <p>{cms.value2Description}</p>
            </div>
          </div>
          <div className="bubble bubble-3">
            <div className="bubble-handler" onClick={expandBubble} />
            <span className="value-x" onClick={closeBubble}>✕</span>
            <div className="value-main">
              <h3>{cms.value3Name}</h3>
              <p className="value-subheader">{cms.value3Blurb}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="value-description">
              <p>{cms.value3Description}</p>
            </div>
          </div>
          <div className="bubble bubble-4">
            <div className="bubble-handler" onClick={expandBubble} />
            <span className="value-x" onClick={closeBubble}>
              ✕
            </span>
            <div className="value-main">
              <h3>{cms.value4Name}</h3>
              <p className="value-subheader">{cms.value4Blurb}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="value-description">
              <p>{cms.value4Description}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="definition">
        <span className="section-arrow-grey">▼</span>
        <h1>{cms.missionHeader}</h1>
        <div className="definition-content">
          <div className="panel">
            <h2>
              Wraparound <span>Infrastructure</span>
            </h2>
            <h3>
              /'rapə,round 'infrə,strək(t)SHər/<br />
              <i>noun</i>
            </h3>
          </div>
          <div className="panel">
            <p>{cms.missionDefinition}</p>
          </div>
        </div>
      </section>

      <section className="model" id="our-model">
        <div className="background-letters" />
        <span className="section-arrow-white">▼</span>
        <h1>{cms.modelHeader}</h1>
        <br />
        <div className="panel panel-crest">
          <img className="model-crest" src={model} />
        </div>
        <div className="panel">
          <p>{cms.modelDescription}</p>
        </div>
      </section>

      <section className="services" id="our-services">
        <span className="section-arrow-grey">▼</span>
        <h1>Spectrum of Services</h1>
        <br />
        <div className="panel">
          <p>
            The ultimate goal of Maslow is to increase the economic mobility of families in disadvantaged communities by influencing the neighborhood ecosystem to better serve its residents. Aligning existing and new resources to improve student outcomes, removing/redesigning physical neighborhood barriers, and lifting up neighborhood assets will dramatically transform communities that have persisted under chronic stressors that produce adverse childhood experiences.
            <br/><br/>
            Designing and developing brick and mortar and determining the right programs to build a successful ecosystem that is both holistic and community-driven does not happen overnight. Projects are a journey. At Maslow, we want to meet you where you are and find innovative ways to move you to the next phase. Over the course of a project's life-cycle, our role as an organization ultimately shifts from being a consultant with project-based engagements to engaging as a full-fledged developer.
          </p>
        </div>
        <button className='explore-button' onClick={showExploreServices}>
            Explore Our Services <Plus className='explore-button-plus' />
        </button>
        <div className='services-container'>
          <h4 className='container-header'>Explore Our Services</h4>

          <div className='block visible'>
            <img className='img' src={school} />
            <p>
              Is there already a high-quality school in the community?
            </p>
            <div className='button-row'>
              <button className='button-yes' onClick={showYes}>Yes</button>
              <button className='button-no' onClick={showNo}>No</button>
            </div>
          </div>

          <div className='block hidden' id='yes'>
            <p>
              Are you interested in developing the community around the school?
            </p>
            <div className='button-row'>
              <button className='button-yes' onClick={showYesYes}>Yes</button>
              <button className='button-no' onClick={showYesNo}>No</button>
            </div>
          </div>

          <div className='block hidden' id='yes-no'>
            <p>
              Maslow's model is centered around co-designing and developing community ecosystems. Is there something else we can help you with?
            </p>
            <div className='button-row'>
              <a href='https://bit.ly/2FruGnN' target='_blank'>
                <button className='button-contact'>Contact Us →</button>
              </a>
            </div>
          </div>

          <div className='hidden' id='yes-yes'>
            <div className='block detail visible'>
              <img className='img' src={animated3} />
              <div className='detail-text'>
                <h4>Community Development</h4>
                <p>Two different starting points</p>
                <ul>
                  <li>Do you have a location in mind, but are seeking capital and forging an idea?</li>
                  <li>Do you have a vision, but are seeking a location and capital?</li>
                </ul>
              </div>
            </div>

            <div className='block detail visible'>
              <img className='img' src={initiation} />
              <div className='detail-text'>
                <h4>Project Initiation</h4>
                <p>Advise planning strategies to establish thoughtful, mixed-income communities</p>
                <p>Support in the development of a community development project vision</p>
                <ul>
                  <li>Facilitate design sprints with community members, stakeholders, and organizations to identify community needs and desires</li>
                  <li>Lead 1:1 stakeholder meetings to share vision, work, and model</li>
                  <li>Develop partnerships with key city and community stakeholders</li>
                </ul>
                <p>Land research and identification</p>
                <ul>
                    <li>Evaluate needs of a given neighborhood based on quantitative and qualitative perspective</li>
                    <li>Look at data to evaluate the health and prosperity of a community</li>
                    <li>Identify areas where additional investment could produce positive results</li>
                </ul>
              </div>
            </div>

            <div className='block detail visible'>
              <img className='img' src={financing} />
              <div className='detail-text'>
                <h4>Project Financing</h4>
                <p>Assist in identifying potential opportunities for investment and development</p>
                <ul>
                  <li>Identify and garner local, federal, and private funding sources</li>
                  <li>Help communities realize the infusion of resources needed to ensure that schools and communities can work closely together to support thriving communities</li>
                </ul>
                <p>Coordinate execution of project financing documents, including pro forma and capital stack</p>
              </div>
            </div>

            <div className='block detail visible'>
              <img className='img' src={conception} />
              <div className='detail-text'>
                <h4>Project Conception</h4>
                <p>Coordinate execution of land feasibility studies, including market analysis, location analysis, usage concept, and risk and cost analysis</p>
                <p>Coordinate site due diligence: market conditions and demand</p>
                <p>Execute and coordinate master planning process in concert with local architects, from preliminary site map to master plan development</p>
              </div>
            </div>

            <div className='block detail visible'>
              <img className='img' src={representative} />
              <div className='detail-text'>
                <h4>Owners Representative</h4>
                <p>Execute land use (entitlement approval) process</p>
                <p>Coordinate planning and control of construction schedule</p>
                <p>Coordinate development of construction documents</p>
                <p>Manage construction process</p>
                <p>Coordinate vendor selection with agreed upon supplier diversity goals</p>
              </div>
            </div>

            <div className='block visible'>
              <p>
                The Maslow team thanks you for the opportunity to work together! We look forward to determining how best to serve your needs.
              </p>
              <div className='button-row'>
                <a href='https://bit.ly/2FruGnN' target='_blank'>
                  <button className='button-contact'>Contact Us →</button>
                </a>
              </div>
            </div>
          </div>

          <div className='block hidden' id='no'>
            <p>
              Are you interested in anchoring the community in a high-quality school?
            </p>
            <div className='button-row'>
              <button className='button-yes' onClick={showNoYes}>Yes</button>
              <button className='button-no' onClick={showNoNo}>No</button>
            </div>
          </div>

          <div className='block hidden' id='no-no'>
            <p>
              At Maslow, we believe that communities should be anchored by high-quality learning environments. Are you thinking about learning and education differently? Reach out!
            </p>
            <div className='button-row'>
              <a href='https://bit.ly/2FruGnN' target='_blank'>
                <button className='button-contact'>Contact Us →</button>
              </a>
            </div>
          </div>

          <div className='hidden' id='no-yes'>
            <div className='block detail visible'>
              <img className='img' src={anchor} />
              <div className='detail-text'>
                <h4>Anchor Development</h4>
                <p>School model development</p>
                <ul>
                  <li>Research school operators that may be a good fit for a community</li>
                  <li>Assemble founding school team, including board members and leadership team</li>
                  <li>Advise in writing the school application, school vision, and model</li>
                </ul>
                <p>Planning and implementation of school until launch</p>
                <ul>
                  <li>Develop student recruitment & hiring practices and strategies</li>
                  <li>Identify school facility options</li>
                  <li>Identify funding sources for school development</li>
                </ul>
              </div>
            </div>

            <div className='block visible'>
              <p>
                Once a high-quality school is designed and its doors are opened, we are eager to co-design and develop the ecosystem around it. Check out how we can help with that <span className='no-yes-more-button' onClick={showNoYesMore}>here</span>.
              </p>
            </div>

            <div className='hidden' id='no-yes-more'>
              <div className='block detail visible'>
                <img className='img' src={animated3} />
                <div className='detail-text'>
                  <h4>Community Development</h4>
                  <p>Two different starting points</p>
                  <ul>
                    <li>Do you have a location in mind, but are seeking capital and forging an idea?</li>
                    <li>Do you have a vision, but are seeking a location and capital?</li>
                  </ul>
                </div>
              </div>

              <div className='block detail visible'>
                <img className='img' src={initiation} />
                <div className='detail-text'>
                  <h4>Project Initiation</h4>
                  <p>Advise planning strategies to establish thoughtful, mixed-income communities</p>
                  <p>Support in the development of a community development project vision</p>
                  <ul>
                    <li>Facilitate design sprints with community members, stakeholders, and organizations to identify community needs and desires</li>
                    <li>Lead 1:1 stakeholder meetings to share vision, work, and model</li>
                    <li>Develop partnerships with key city and community stakeholders</li>
                  </ul>
                  <p>Land research and identification</p>
                  <ul>
                      <li>Evaluate needs of a given neighborhood based on quantitative and qualitative perspective</li>
                      <li>Look at data to evaluate the health and prosperity of a community</li>
                      <li>Identify areas where additional investment could produce positive results</li>
                  </ul>
                </div>
              </div>

              <div className='block detail visible'>
                <img className='img' src={financing} />
                <div className='detail-text'>
                  <h4>Project Financing</h4>
                  <p>Assist in identifying potential opportunities for investment and development</p>
                  <ul>
                    <li>Identify and garner local, federal, and private funding sources</li>
                    <li>Help communities realize the infusion of resources needed to ensure that schools and communities can work closely together to support thriving communities</li>
                  </ul>
                  <p>Coordinate execution of project financing documents, including pro forma and capital stack</p>
                </div>
              </div>

              <div className='block detail visible'>
                <img className='img' src={conception} />
                <div className='detail-text'>
                  <h4>Project Conception</h4>
                  <p>Coordinate execution of land feasibility studies, including market analysis, location analysis, usage concept, and risk and cost analysis</p>
                  <p>Coordinate site due diligence: market conditions and demand</p>
                  <p>Execute and coordinate master planning process in concert with local architects, from preliminary site map to master plan development</p>
                </div>
              </div>

              <div className='block detail visible'>
                <img className='img' src={representative} />
                <div className='detail-text'>
                  <h4>Owners Representative</h4>
                  <p>Execute land use (entitlement approval) process</p>
                  <p>Coordinate planning and control of construction schedule</p>
                  <p>Coordinate development of construction documents</p>
                  <p>Manage construction process</p>
                  <p>Coordinate vendor selection with agreed upon supplier diversity goals</p>
                </div>
              </div>
            </div>

            <div className='block visible'>
              <p>
                The Maslow team thanks you for the opportunity to work together! We look forward to determining how best to serve your needs.
              </p>
              <div className='button-row'>
                <a href='https://bit.ly/2FruGnN' target='_blank'>
                  <button className='button-contact'>Contact Us →</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="projects" id="highlighted-projects">
        <span className="section-arrow-white">▼</span>
        <div className="background-letters" />
        <h1>{cms.projectsHeader}</h1>
        <div className="projects-content">
          <Link to='lighthouse-project' className='project'>
            <img src={Lighthouse} className='project-image' alt='Lighthouse Project' />
            <span className='project-image-layer'></span>
            <div className='project-text'>
              <h4 className='project-title'>Lighthouse Project</h4>
              <p className='project-blurb'>Building Holistic Ecosystems Anchored By Learning</p>
              <button className='project-button'>→</button>
            </div>
          </Link>
          <Link to='clayborn-temple' className='project'>
            <img src={Clayborn} className='project-image' alt='Clayborn temple' />
            <span className='project-image-layer'></span>
            <div className='project-text'>
              <h4 className='project-title'>Clayborn Temple</h4>
              <p className='project-blurb'>Honoring the Clayborn Temple Civil Rights Treasure</p>
              <button className='project-button'>→</button>
            </div>
          </Link>
          <Link to='mcf23' className='project'>
            <img src={Tulsa} className='project-image' alt='MCF23' />
            <span className='project-image-layer'></span>
            <div className='project-text'>
              <h4 className='project-title'>MCF23</h4>
              <p className='project-blurb'>Reimagining Black Wall Street In North Tulsa</p>
              <button className='project-button'>→</button>
            </div>
          </Link>
        </div>
      </section>

      <section className="team" id="team">
        <div className="background-click-zone" onClick={closeBio} />
        <span className="section-arrow-grey">▼</span>
        <h1>{cms.teamHeader}</h1>

        <div className="team-container">
          <div className="person-box person-box-1">
            <div className="click-handler" onClick={expandBio} />
            <span className="bio-x" onClick={closeBio}>✕</span>
            <div className="bio-main">
              <img src={derwin} className="person-img" />
              <h3 className="person-name">{cms.teammate1Name}</h3>
              <p className="person-role">{cms.teammate1Role}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="bio-description">
              <p>{cms.teammate1Bio}</p>
            </div>
          </div>

          <div className="person-box person-box-2">
            <div className="click-handler" onClick={expandBio} />
            <span className="bio-x" onClick={closeBio}>✕</span>
            <div className="bio-main">
              <img src={nora} className="person-img" />
              <h3 className="person-name">{cms.teammate2Name}</h3>
              <p className="person-role">{cms.teammate2Role}</p>
              <Plus className="plus-icon" />
            </div>
            <div className="bio-description">
              <p>{cms.teammate2Bio}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact">
        <span className="section-arrow-white">▼</span>
        <div className="background-letters" />
        <div id="contact-us">
          <img src={animated3} />
          <h1>{cms.contactHeader}</h1>
          <p>{cms.contactSubheader}</p>
          <div className="buttons">
            <div className="box box-1">
              <p>{cms.contactBox1Text}</p>
              <a
                className="contact-link"
                href="http://bit.ly/2FruGnN"
                target="_blank"
              >
                {cms.contactBox1Button}
              </a>
            </div>
            <div className="box box-2">
              <p>{cms.contactBox2Text}</p>
              <a
                className="contact-link"
                href="http://bit.ly/2FsO5F5"
                target="_blank"
              >
                {cms.contactBox2Button}
              </a>
            </div>
            <div className="box box-3">
              <p>{cms.contactBox3Text}</p>
              <a
                className="contact-link"
                href="http://bit.ly/2CQ1XHt"
                target="_blank"
              >
                {cms.contactBox3Button}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="footer">
        <div className="social-links">
          <a href="https://twitter.com/MaslowDevInc" target="_blank">
            <Twitter className="social-icon" />
          </a>
          <a
            href="https://www.instagram.com/maslowdevinc/?hl=en"
            target="_blank"
          >
            <Instagram className="social-icon" />
          </a>
          <a href="https://www.facebook.com/Maslowdevinc/" target="_blank">
            <Facebook className="social-icon" />
          </a>
          <a
            href="https://www.linkedin.com/company/maslow-development-inc"
            target="_blank"
          >
            <LinkedIn className="social-icon" />
          </a>
        </div>
        <p className="address">
        1779 Kirby Pkwy #1 #604, Memphis, TN 38138
        </p>
        <p className="credit">
          Rendering provided by A2H & DPZ, a collaborative design team.
          Copyright 2018.
        </p>
        <p className="copyright">Ⓒ Maslow Development Inc.</p>
      </section>
    </div>
  );
}

export const query = graphql`
  query Homepage {
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            welcomeTop
            welcomeBottom
            infographicHeader
            infographicCloser
            illustration1Header
            illustration1Description
            illustration2Header
            illustration2Description
            illustration3Header
            illustration3Description
            valuesHeader
            value1Name
            value1Blurb
            value1Description
            value2Name
            value2Blurb
            value2Description
            value3Name
            value3Blurb
            value3Description
            value4Name
            value4Blurb
            value4Description
            missionHeader
            missionDefinition
            modelHeader
            modelDescription
            projectsHeader
            projectsLabel1
            projectsLabel2
            projectsAsterisk
            teamHeader
            teammate1Name
            teammate1Role
            teammate1Bio
            teammate2Name
            teammate2Role
            teammate2Bio
            contactHeader
            contactSubheader
            contactBox1Text
            contactBox1Button
            contactBox2Text
            contactBox2Button
            contactBox3Text
            contactBox3Button
            footerOffice1
            footerOffice2
          }
        }
      }
    }
  }
`;

export default Home;



// WEBPACK FOOTER //
// ./src/pages/index.js